export default function alertPhoto (){
  const content = '[data-alertphoto="content"]';
  const close = $('[data-alertphoto="close"]');

  close.click(function() {
    $(this).closest(content).remove();
  })
}